<template>
    <v-list-item>
        <v-list-item-content>
            <v-list-item-title class="title">
                {{ fullName }}
            </v-list-item-title>
            <v-list-item-subtitle>
                {{ roles }}
            </v-list-item-subtitle>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    export default {
        name: 'NavHeaderPartial',
        data: () => ({}),
        computed: {
            fullName() {
                let first = this.$store.getters['identity/getFirstName'];
                let last = this.$store.getters['identity/getLastName'];
                return first + " " + last;
            },
            roles() {
                let roles = [];
                if (this.$store.getters['identity/getRoles']) {
                    this.$store.getters['identity/getRoles'].forEach(role => {
                        if (role === 'ROLE_ADMIN') {
                            roles.push(this.$t('roles.admin'));
                        } else if (role === 'ROLE_APPROVER') {
                            roles.push(this.$t('roles.approver'));
                        } else if (role === 'ROLE_BUYER') {
                            roles.push(this.$t('roles.buyer'));
                        }
                    });
                }
                return roles.join(', ');
            }
        }
    }
</script>
